import React from "react";
import styled, { css, keyframes, useTheme } from "styled-components";
import { variant } from "styled-system";
import { Flex } from "./Flex";
import { Text } from "./Text";
export const variants = {
    lg: {
        fontSize: "24px",
        height: "24px",
    },
    mc: {
        height: "4px",
    },
    sm: {
        fontSize: "10px",
        fontWeight: "bold",
        height: "16px",
    },
};
const progress = keyframes({
    "0%": { backgroundPositionX: "100%" },
    "100%": { backgroundPositionX: "-100%" },
});
const StyledBar = styled(Flex)({
    justifyContent: "flex-end",
}, variant({ variants }), ({ indeterminate, theme: { colors: { progressBarColors }, }, }) => indeterminate &&
    css `
      background: linear-gradient(
        90deg,
        ${progressBarColors.progress} 0%,
        ${progressBarColors.progress} 20%,
        transparent 25%,
        transparent 50%,
        ${progressBarColors.progress} 55%,
        ${progressBarColors.progress} 70%,
        transparent 75%,
        transparent 95%,
        ${progressBarColors.progress} 100%
      );
      background-size: 400% 100%;
      animation: ${progress} 2s ease-out infinite;
    `);
export const calculateWidth = (value, max) => {
    if (max === 0)
        return 0;
    return Math.round((value / max) * 100);
};
export const ProgressBar = (props) => {
    const { colors: { progressBarColors }, } = useTheme();
    const { borderRadius = 0, backgroundColor = progressBarColors.background, color = progressBarColors.containerBackground, displayValues = false, locale = "EN-us", max, size = "lg", textColor = progressBarColors.text, value, } = props;
    const indeterminate = typeof value !== "number" || typeof max !== "number";
    const percent = `${indeterminate ? 100 : calculateWidth(value, max)}%`;
    return (React.createElement(Flex, { flexDirection: "row", "data-testid": "ProgressBar", width: "100%" },
        React.createElement(Flex, { flex: 1, backgroundColor: backgroundColor, borderRadius: borderRadius },
            React.createElement(StyledBar, { backgroundColor: color, borderRadius: borderRadius, width: percent, variant: size, indeterminate: indeterminate }, displayValues && size === "sm" && (React.createElement(Text, { color: textColor, "data-testid": "smallTextDisplay", pb: 1, pr: 1, position: "relative", left: parseInt(percent, 10) > 10 ? 0 : 10, whiteSpace: "nowrap" }, percent)))),
        displayValues && size === "lg" && (React.createElement(Flex, { "data-testid": "largeDisplayValues" },
            React.createElement(Text, { color: textColor, pt: 1, px: 2 }, value === null || value === void 0 ? void 0 :
                value.toLocaleString(locale),
                "\u00A0/\u00A0", max === null || max === void 0 ? void 0 :
                max.toLocaleString(locale)),
            React.createElement(Text, { color: textColor, pt: 1, px: 2 }, percent)))));
};
